module.exports = __webpack_public_path__ + "fonts/SamsungOne-600C_v1.1.0eb3cdd7.ttf";